// SPDX-License-Identifier: GPL-3.0-only
// Copyright (C) 2026 Kyle Johnson
// This file is part of Hushold.
//
// Hushold is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as
// published by the Free Software Foundation, version 3.

import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { IS_NATIVE } from './platform.js';

// DECISION: On the web, "export" means a browser download (anchor + object URL) —
// unchanged. On native there is no download folder UX; the platform-idiomatic
// flow is to write the file to app storage and hand it to the system share sheet
// (Files, AirDrop, email, cloud). This is where @capacitor/filesystem and
// @capacitor/share earn their keep (Phase 1). Callers stay platform-agnostic.
export async function exportTextFile(
  filename: string,
  text: string,
  mimeType: string,
): Promise<void> {
  if (IS_NATIVE) {
    const written = await Filesystem.writeFile({
      path: filename,
      data: text,
      directory: Directory.Cache,
      encoding: Encoding.UTF8,
    });
    await Share.share({
      title: filename,
      text: `Hushold export: ${filename}`,
      url: written.uri,
      dialogTitle: 'Export',
    });
    return;
  }

  const blob = new Blob([text], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
